import React from 'react';
import { Helmet } from 'react-helmet';

const SEOComponent = ({
  title,
  description,
  url,
  image,
  keywords,
  type = "website",
  schema,
  noindex = false
}) => {
  // Default keywords: residential heat pump readiness & sizing first, heritage/churches secondary
  const defaultKeywords = "heat pump sizing, heat pump readiness, is my home ready for a heat pump, heat loss survey, home heat loss survey UK, MCS heat loss calculation, boiler monitoring sensor, clip-on boiler sensor, heating system monitoring, residential heat pump, air source heat pump sizing, heat pump suitability check, radiator sizing for heat pumps, flow temperature monitoring, low temperature heating, heat pump feasibility, boiler replacement heat pump, home decarbonisation, reduce heating bills, heritage building heat pumps, listed building heat pumps, heat pumps for churches, heat pump case studies UK";

  const finalKeywords = keywords || defaultKeywords;

  // Default structured data
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Rebel Heat",
    "url": "https://www.rebelheat.co.uk",
    "logo": "https://www.rebelheat.co.uk/logo.png",
    "description": "A clip-on boiler sensor that measures your home's real heating performance and proves whether it's ready for a heat pump. Data-driven heat loss surveys and heat pump sizing for UK homes, plus heritage buildings and churches.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GB"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.rebelheat.co.uk"
    ]
  };

  const finalSchema = schema || defaultSchema;

  return (
    <Helmet>
      {/* General tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={finalKeywords} />

      <link rel="canonical" href={url} />

      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image || "https://www.rebelheat.co.uk/church.jpeg"} />
      <meta property="og:site_name" content="Rebel Heat" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || "https://www.rebelheat.co.uk/church.jpeg"} />

      {/* Additional SEO tags */}
      <meta
        name="robots"
        content={noindex
          ? "noindex, nofollow"
          : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"}
      />
      <meta name="author" content="Rebel Heat" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="United Kingdom" />

      {/* Language and content tags */}
      <meta httpEquiv="content-language" content="en-GB" />
      <meta name="language" content="English" />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default SEOComponent;
